(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/input-range-group/assets/javascripts/input-range-group-v2.js') >= 0) return;  svs.modules.push('/components/lb-ui/input-range-group/assets/javascripts/input-range-group-v2.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useState,
  useEffect,
  useRef,
  useCallback
} = React;
const {
  Input
} = svs.ui.form;
const {
  DebounceOnEvent
} = svs.components.lbUi;
const {
  clx
} = svs.components.lbUtils;
const {
  InputRange
} = svs.components.lbUi.inputRange;
const ValidKeys = {
  ALT_KEY: 'Alt',
  ARROW_DOWN_KEY: 'ArrowDown',
  ARROW_LEFT_KEY: 'ArrowLeft',
  ARROW_RIGHT_KEY: 'ArrowRight',
  ARROW_UP_KEY: 'ArrowUp',
  BACKSPACE_KEY: 'Backspace',
  CONTROL_KEY: 'Control',
  ENTER_KEY: 'Enter',
  ESCAPE_KEY: 'Escape',
  META_KEY: 'Meta',
  SHIFT_KEY: 'Shift',
  TAB_KEY: 'Tab'
};
const MS_TO_AVOID_SAFARI_HISTORY_LIMIT_100_TIMES_IN_30_SECONDS = 350;
const InputRangeGroupV2 = props => {
  const {
    branding,
    className,
    isInfiniteMax,
    maxCap,
    maxLabel,
    minCap,
    minLabel,
    onChange,
    selectedMin: propsMin,
    selectedMax: propsMax,
    suffix
  } = props;
  const iMin = useRef(null);
  const iMax = useRef(null);
  const [currRange, setCurrRange] = useState({
    min: propsMin,
    max: propsMax
  });
  const formatMax = (value, maxValue) => value >= maxValue ? "".concat(maxValue, "+") : value;
  const tpl = useRef(null);
  const setInputSize = (inputRef, value) => {
    if (inputRef !== null && inputRef !== void 0 && inputRef.current) {
      tpl.current.innerText = value;
      inputRef.current.style.width = "".concat(tpl.current.offsetWidth + 2, "px");
    }
  };
  const setSize = useCallback((min, max) => {
    setInputSize(iMin, min);
    setInputSize(iMax, max);
  }, []);
  useEffect(() => {
    const el = document.createElement('div');
    const styles = window.getComputedStyle(iMin.current);
    let cssText = styles.cssText;
    const keys = ['border-style', 'border-width', 'border-collapse', 'border-inline-end', 'border-inline-start', 'border-spacing', 'font', 'font-kerning', 'font-optical-sizing', 'font-palette', 'font-synthesis', 'letter-spacing', 'margin', 'margin-bottom', 'margin-left', 'margin-right', 'margin-top', 'margin-inline', 'max-height', 'max-inline-size', 'max-width', 'min-height', 'min-inline-size', 'min-width', 'padding', 'padding-bottom', 'padding-left', 'padding-right', 'padding-top', 'padding-inline', 'text-indent'];
    if (!cssText) {
      cssText = Array.from(styles).filter(property => keys.includes(property)).reduce((str, property) => "".concat(str).concat(property, ":").concat(styles.getPropertyValue(property), ";"), '');
    }
    el.style.cssText = "".concat(cssText, ";display:inline;visibility:hidden;");
    document.body.append(el);
    tpl.current = el;
    return () => {
      el === null || el === void 0 || el.remove();
    };
  }, []);
  useEffect(() => {
    setSize(propsMin, formatMax(propsMax, maxCap));
    if (propsMin === minCap && propsMax === maxCap) {
      setCurrRange({
        min: propsMin,
        max: propsMax
      });
    }
  }, [maxCap, minCap, props, propsMax, propsMin, setSize]);
  const handleMinChange = _ref => {
    let {
      target
    } = _ref;
    if (target.value) {
      setCurrRange(_objectSpread(_objectSpread({}, currRange), {}, {
        min: parseInt(target.value, 10)
      }));
    }
  };
  const handleMinBlur = _ref2 => {
    let {
      target
    } = _ref2;
    const newMin = Math.min(Math.max(parseInt(target.value || 0, 10), minCap), currRange.max);
    setCurrRange(_objectSpread(_objectSpread({}, currRange), {}, {
      min: newMin
    }));
    onChange({
      selectedMin: newMin,
      selectedMax: currRange.max
    });
  };
  const handleMaxChange = _ref3 => {
    let {
      target
    } = _ref3;
    if (target.value) {
      setCurrRange(_objectSpread(_objectSpread({}, currRange), {}, {
        max: parseInt(target.value, 10)
      }));
    }
  };
  const handleMaxBlur = _ref4 => {
    let {
      target
    } = _ref4;
    const newMax = Math.min(Math.max(parseInt(target.value || 0, 10), currRange.min), maxCap);
    setCurrRange(_objectSpread(_objectSpread({}, currRange), {}, {
      max: newMax
    }));
    onChange({
      selectedMin: currRange.min,
      selectedMax: newMax
    });
  };
  const handleRangeChangeDirectly = _ref5 => {
    let {
      selectedMin,
      selectedMax
    } = _ref5;
    const max = isInfiniteMax && selectedMax === isInfiniteMax ? Infinity : selectedMax;
    setCurrRange({
      min: selectedMin,
      max
    });
    setSize(selectedMin, formatMax(max, maxCap));
  };
  const handleRangeChangeDelayed = _ref6 => {
    let {
      selectedMin,
      selectedMax
    } = _ref6;
    const max = isInfiniteMax && selectedMax === isInfiniteMax ? Infinity : selectedMax;
    onChange({
      selectedMin,
      selectedMax: max
    });
    setSize(selectedMin, formatMax(max, maxCap));
  };
  const handleKeyDown = _ref7 => {
    let {
      key,
      target
    } = _ref7;
    if (!/[0-9]/.test(key) && !Object.values(ValidKeys).includes(key)) {
      return false;
    }
    if (key === ValidKeys.ENTER_KEY) {
      target.blur();
    }
  };
  const handleKeyUp = (inputRef, value) => {
    if (value) {
      setInputSize(inputRef, value);
    }
  };
  const handleClick = _ref8 => {
    let {
      target
    } = _ref8;
    target.focus();
    target.select();
  };
  const getMaxValue = () => {
    const isFocused = document.activeElement === iMax.current;
    return !isFocused && isInfiniteMax && currRange.max === maxCap ? "".concat(maxCap, "+") : currRange.max;
  };
  return React.createElement("div", {
    className: clx('input-range-group-v2', {
      ["input-range-group-v2-".concat(branding)]: branding
    }, className),
    "data-testid": "qa-input-range-group"
  }, React.createElement("div", {
    className: "input-range-field"
  }, React.createElement(DebounceOnEvent, {
    delayMS: MS_TO_AVOID_SAFARI_HISTORY_LIMIT_100_TIMES_IN_30_SECONDS,
    onEventDelayed: handleRangeChangeDelayed,
    onEventDirectly: handleRangeChangeDirectly
  }, _ref9 => {
    let {
      handleEvent
    } = _ref9;
    return React.createElement(InputRange, {
      hasIcons: false,
      maxCap: maxCap,
      minCap: minCap,
      offsetRange: -32,
      onChange: handleEvent,
      selectedMax: currRange.max,
      selectedMin: currRange.min
    });
  })), React.createElement("div", {
    className: "input-range-values"
  }, React.createElement(Input, {
    "aria-label": minLabel,
    className: "std-input-100 input-range-group-min qa-input-range-group-min",
    max: maxCap,
    min: minCap,
    onBlur: handleMinBlur,
    onChange: handleMinChange,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: _ref10 => {
      let {
        target
      } = _ref10;
      return handleKeyUp(iMin, target.value);
    },
    pattern: "[0-9]+-",
    placeholder: "",
    refElem: iMin,
    suffix: suffix,
    type: "tel",
    value: currRange.min
  }), React.createElement(Input, {
    "aria-label": maxLabel,
    className: "std-input-100 input-range-group-max qa-input-range-group-max",
    max: maxCap,
    min: minCap,
    onBlur: handleMaxBlur,
    onChange: handleMaxChange,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: _ref11 => {
      let {
        target
      } = _ref11;
      return handleKeyUp(iMax, target.value);
    },
    pattern: "[0-9]+-",
    placeholder: "",
    refElem: iMax,
    suffix: suffix,
    type: "tel",
    value: getMaxValue()
  })));
};
InputRangeGroupV2.defaultProps = {
  isInfiniteMax: false,
  maxLabel: 'Högsta andelspris',
  minLabel: 'Minsta andelspris'
};
setGlobal('svs.components.lbUi.inputRangeGroup.InputRangeGroupV2', InputRangeGroupV2);

 })(window);